module.exports = __webpack_public_path__ + "img/sj_gangguanzhizao.7d0972ce.jpg";